module.exports = __webpack_public_path__ + "static/media/elementary-school-banner.8aa06ac0.jpg";